export default "__VITE_ASSET__Cn8abv$F__"